import React from 'react';
import { ParentSize } from '@visx/responsive';

interface Props {
  height?: number;
  children: (dimensions: { width: number; height: number }) => React.ReactNode;
}

/**
 * Wraps visx's ParentSize to provide responsive width to chart children.
 * Uses a fixed height (default 300) and fluid width.
 */
export const ResponsiveChartWrapper = ({ height = 300, children }: Props) => (
  <ParentSize debounceTime={100}>
    {({ width }) =>
      width > 0 ? children({ width, height }) : null
    }
  </ParentSize>
);
